import {
  addonsLoading,
  addonsError,
  setAddonsList,
} from "../../slices/addonsSlice";
import {
  getService,
  createService,
  deleteAllService,
  deleteRowService,
  updateService,
  softDeleteService,
  softDeleteAllService,
  restoreRowService,
  restoreAllService,
} from "../../services/addons";

export const getAction = () => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await getService();
    if (response?.error) {
      dispatch(addonsError(response.error));
      return;
    } else {
      dispatch(setAddonsList(response));
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await createService(formData);
    if (response?.error) {
      dispatch(addonsError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(addonsLoading());
  try {
    const response = await updateService(formData);

    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        addonsError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await softDeleteService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        addonsError(`Failed to softdelete row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const softDeleteAllAction = (table, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await softDeleteAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(addonsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        addonsError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const deleteAllAction = (table, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await deleteAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(addonsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        addonsError(`Failed to recover row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};

export const restoreAllAction = (table, username) => async (dispatch) => {
  dispatch(addonsLoading());
  try {
    const response = await restoreAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(addonsError(`Failed to recover records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(addonsError(error.message));
    return;
  }
};
